import React, { useEffect, useState } from "react";
import WOW from "wowjs";
import News from "../Shared/News";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Popup from "../Shared/Popup";
import WhatWeHaveDone from "../Shared/WhatWeHaveDone";
import ClientLogo from "../Shared/ClientLogo";
import { Icon } from "@iconify/react";
import { Helmet } from "react-helmet-async";

const AboutUs = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const [watchReel, setWatchReel] = useState(false);
  gsap.registerPlugin(ScrollTrigger);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const watch_reel = () => {
    setWatchReel(true);
  };

  const close_reel = () => {
    setWatchReel(false);
  };
  useEffect(() => {

    const wow = new WOW.WOW({
      live: false, // Set to false if you want to trigger the animations only once
    });
    wow.init();


  }, []);



  return (
    <>
      <Helmet>
        <title>About Us - Creative Digital Agency | Reverse Thought</title>
        <meta name="description" content="Reverse Thought is a creative web &amp; mobile design and development agency. We combine strategy with art to offer creative solutions for businesses. Connect with us!" />
        <meta name="robots" content="max-image-preview:large" />
        <meta name="google-site-verification" content="HoCjksaLBwM7qPH8Nt-Rzrqa5K02wXYiJwFSEMC4j8g" />
        <meta name="p:domain_verify" content="f307b6f44d53f755ef67d9a9a3666de7" />
        <link rel="canonical" href="https://www.reversethought.com/about-us" />
        <meta name="generator" content="All in One SEO (AIOSEO) 4.4.7.1" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="Creative Agency In Mumbai | Branding Agency India - Reverse Thought" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="About Us - Creative Digital Agency | Reverse Thought" />
        <meta property="og:description" content="Reverse Thought is a creative web &amp; mobile design and development agency. We combine strategy with art to offer creative solutions for businesses. Connect with us!" />
        <meta property="og:url" content="https://www.reversethought.com/blogs/about-us/" />
        <meta property="og:image" content="https://www.reversethought.com/images/RT-Banner-mob.jpg" />
        <meta property="og:image:secure_url" content="https://www.reversethought.com/images/RT-Banner-mob.jpg" />
        <meta property="article:published_time" content="2017-08-08T10:06:52+00:00" />
        <meta property="article:modified_time" content="2022-08-01T08:58:25+00:00" />
        <meta property="article:publisher" content="https://www.facebook.com/rtcspl/" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@rthoughtindia" />
        <meta name="twitter:title" content="About Us - Creative Digital Agency | Reverse Thought" />
        <meta name="twitter:description" content="Reverse Thought is a creative web &amp; mobile design and development agency. We combine strategy with art to offer creative solutions for businesses. Connect with us!" />
        <meta name="twitter:image" content="https://www.reversethought.com/images/RT-Banner-mob.jpg" />
        <meta name="google" content="nositelinkssearchbox" />
      </Helmet>
      {watchReel === true ? <Popup close_reel={close_reel} /> : ""}
      <section className="aboitUsSection">
        <div className="content_container position-relative">
          <div className="servicePageBanner">
            <h1 className="colorBlack fw-800 projectHeading wow animate__animated animate__fadeInUp">
              We're A Digital Agency
            </h1>
            <p className="colorBlack fw-400 projectDesc wow animate__animated animate__fadeInUp animation_delay_100ms">
              Unleash Your Brand's Potential with Our Strategic and Creative
              Expertise in the Beautiful Online Space
            </p>
            <p
              className="watch_reel_txt mb-0 mt-0 wow animate__animated animate__fadeInUp animation_delay_200ms"
              onMouseEnter={props.onMouseEnterSmall}
              onMouseLeave={props.onMouseLeaveSmall}
            >
              <span
                className="colorBlack fw-500 watch_reel_txt wow text-center d-flex"
                onClick={watch_reel}
                onMouseEnter={props.onMouseEnterSmall}
                onMouseLeave={props.onMouseLeaveSmall}
              >
                <img
                  src="/images/icons/play.jpg"
                  alt="play"
                  className="img-fluid hero_reel_play "
                />
                &nbsp; Watch the Agency Reel!
              </span>
            </p>

            <h4 className="serviceKeyPoints colorBlack fw-800 wow animate__animated animate__fadeInUp animation_delay_300ms">
              Agility.
            </h4>
            <h4 className="serviceKeyPoints colorBlack fw-800 wow animate__animated animate__fadeInUp animation_delay_500ms">
              Strategy.
            </h4>
            <h4 className="serviceKeyPoints colorRed fw-800 wow animate__animated animate__fadeInUp animation_delay_700ms">
              Technology.
            </h4>
            <img
              src="/images/about-us.png"
              className="about-us"
              alt="about-us"
            />
          </div>
        </div>
      </section>

      <section className="aboitUsSectionwwd whatWeDo">
        <div className="content_container">
          <h2 className="sectionHead colorBlack fw-800 wow">
            <img src="/images/icons/line.jpg" alt="line" />
            What We Do
          </h2>
          <div className="row m-0 whatwedoTabs">
            <div className="col-sm-6 p-0 whatwedoTabsL">
              <ul>
                <li
                  onClick={() => handleTabClick(0)}
                  className={
                    activeTab === 0
                      ? "wow animate__animated animate__fadeInUp tabhover active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  <span className="fw-800">01</span>
                  Websites/App
                </li>
                <li
                  onClick={() => handleTabClick(1)}
                  className={
                    activeTab === 1
                      ? "wow animate__animated animate__fadeInUp tabhover active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  <span className="fw-800">02</span>
                  Video Production
                </li>
                <li
                  onClick={() => handleTabClick(2)}
                  className={
                    activeTab === 2
                      ? "wow animate__animated animate__fadeInUp     tabhover active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  <span className="fw-800">03</span>
                  Digital Marketing
                </li>
                <li
                  onClick={() => handleTabClick(3)}
                  className={
                    activeTab === 3
                      ? "wow animate__animated animate__fadeInUp    tabhover active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  <span className="fw-800">04</span>
                  Creative Design
                </li>
                <li
                  onClick={() => handleTabClick(4)}
                  className={
                    activeTab === 4
                      ? "wow animate__animated animate__fadeInUp   tabhover active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  <span className="fw-800">05</span>
                  Digital Activations
                </li>
                <li
                  onClick={() => handleTabClick(5)}
                  className={
                    activeTab === 5
                      ? "wow animate__animated animate__fadeInUp  tabhover active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  <span className="fw-800">06</span>
                  Photography
                </li>
              </ul>
            </div>
            <div className="col-sm-6 p-0 whatwedoTabsR">
              {activeTab === 0 && (
                <div
                  className={
                    activeTab === 0
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <ul className="d-flex">
                    <li className="colorBlack fw-800">UI/UX</li>
                    <li className="colorBlack fw-800">Backend Development</li>
                    <li className="colorBlack fw-800">Front-end Development</li>
                    <li className="colorBlack fw-800">Mobile App design</li>
                    <li className="colorBlack fw-800">WordPress Development</li>
                  </ul>
                  <p className="colorBlack fw-400">
                    Let’s energise and elevate your website presence, with the
                    right balance of business strategy and user excitement. We
                    conceptualise, strategise, design and develop websites and
                    apps that establish new design standards in the industry,
                    while performing flawlessly on various devices. We focus
                    heavily on user experience & brand upliftment by leveraging
                    design, content and technology.
                  </p>
                  <a
                    href="/website-and-mobile/"
                    className="unsetAll"
                    onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 1 && (
                <div
                  className={
                    activeTab === 1
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <ul className="d-flex">
                    <li className="colorBlack fw-800">Corporate Profiles</li>
                    <li className="colorBlack fw-800">Corporate Profiles</li>
                    <li className="colorBlack fw-800">AVs </li>
                    <li className="colorBlack fw-800">Video Editing</li>
                    {/* <li className="colorBlack fw-800">2d Animation</li> */}
                  </ul>
                  <p className="colorBlack fw-400">
                    A video is the best marketing tool for business. We
                    conceptualise and produce a broad range of videos from
                    corporate profiles to specific application videos. Through a
                    mix of on-ground & aerial photography, graphics, animation
                    and many more styles we can produce any kind of film for any
                    application that you can think of.
                  </p>
                  <a
                    href="/video-production/"
                    className="unsetAll"
                    onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 2 && (
                <div
                  className={
                    activeTab === 2
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <ul className="d-flex">
                    <li className="colorBlack fw-800">SEO</li>
                    <li className="colorBlack fw-800">
                      Social Media Marketing
                    </li>
                    <li className="colorBlack fw-800">Performance Marketing</li>
                    <li className="colorBlack fw-800">Integrated Marketing</li>
                    {/* <li className="colorBlack fw-800">Integrated Marketing  </li> */}
                    {/* <li className="colorBlack fw-800">
                      SMS & Whatsapp Campaigns
                    </li> */}
                  </ul>
                  <p className="colorBlack fw-400">
                    If your business isn’t online and visible to your customers,
                    you’re missing out on a crucial opportunity to grow. Through
                    a range of tools such as SEO, SEM as well as social media
                    marketing we create the right strategy and content to
                    achieve your business goals both organically and through
                    influencer and paid marketing.
                  </p>
                  <a
                    href="/digital-marketing/"
                    className="unsetAll"
                    onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 3 && (
                <div
                  className={
                    activeTab === 3
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <ul className="d-flex">
                    <li className="colorBlack fw-800">Print design</li>
                    <li className="colorBlack fw-800">Branding</li>
                    <li className="colorBlack fw-800"> Creative Design</li>
                    {/* <li className="colorBlack fw-800">
                      Internal Communication
                    </li> */}
                  </ul>
                  <p className="colorBlack fw-400">
                    Creativity is the backbone of our agency and the reason for
                    us to do what we do. We design all kinds of branding
                    materials as well as collaterals that captivate and
                    effectively send the message across. We handle the design
                    and content for all kinds of digital and print creatives
                  </p>
                  <a
                    href="/Creative-Services"
                    className="unsetAll"
                    onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 4 && (
                <div
                  className={
                    activeTab === 4
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <ul className="d-flex">
                    <li className="colorBlack fw-800">AR Filters</li>
                    <li className="colorBlack fw-800">Games</li>
                    <li className="colorBlack fw-800">
                      SMS & Whatsapp Campaigns
                    </li>
                  </ul>
                  <p className="colorBlack fw-400">
                    Break the clutter and engage your audience through custom
                    developed digital activations in the form of apps, games,
                    filters and more. We work closely with your team to develop
                    concepts that add weight to your messaging and develop the
                    assets to execute your campaign.
                  </p>
                  <a
                    href="/Digital-Activation-Services"
                    className="unsetAll"
                    onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 5 && (
                <div
                  className={
                    activeTab === 5
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft fifth "
                      : "whatWeDoTabsResult "
                  }
                >
                  <ul className="d-flex">
                    <li className="colorBlack fw-800">Profile Shoot</li>
                    <li className="colorBlack fw-800">Corporate Shoot</li>
                    <li className="colorBlack fw-800">
                      Drone Assisted Photography
                    </li>
                  </ul>
                  <p className="colorBlack fw-400">
                    Capture the essence of your brand with our photography
                    service, where we bring your vision to life through expertly
                    crafted visuals that resonate with your audience. We craft
                    captivating images that not only capture moments but also
                    engage your audience, adding a unique and compelling
                    dimension to your brand.
                  </p>
                  <a
                    href="/still-photography/"
                    className="unsetAll"
                    onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="webServicePageClient ourRecentClients">
        <div className="content_container">
          <h2 className="sectionHead colorBlack fw-800 wow">
            <img src="/images/icons/line.jpg" alt="line" />
            Our Recent Clients
          </h2>
          <ClientLogo client="commonClient" />
        </div>
      </section>
      <WhatWeHaveDone />

      <section className="ourValueSection">
        <div className="content_container">
          <h2 className="sectionHead colorBlack fw-800 wow">
            <img src="/images/icons/line.jpg" alt="line" />
            Our Values
          </h2>
          <p className="projectDesc colorBlack fw-800 wow animate__animated animate__fadeInUp animation_delay_200ms">
            <span className="colorRed">Through the years,</span> we have been
            shaped and formed by both successes and failures.
          </p>
          <div className="gridSystem">
            <div className="gridSystemInner wow animate__animated animate__fadeInUp animation_delay_100ms">
              <img
                src="/images/about/pn3.png"
                alt="Our Value"
                className="img-fluid"
              />
              <h4 className="colorRed fw-800">Strong Understanding</h4>
              <p className="colorBlack fw-400">
                Research, communication and understanding help us get closer to
                your audience and get a sense of your business and what can
                bring results.
              </p>
            </div>
            <div className="gridSystemInner wow animate__animated animate__fadeInUp animation_delay_200ms">
              <img
                src="/images/about/pn4.png"
                alt="Our Value"
                className="img-fluid"
              />
              <h4 className="colorRed fw-800">Sound Strategy</h4>
              <p className="colorBlack fw-400">
                Results happen when you have the right plan and the tools to
                measure their effectiveness.
              </p>
            </div>
            <div className="gridSystemInner wow animate__animated animate__fadeInUp animation_delay_300ms">
              <img
                src="/images/about/pn2.png"
                alt="Our Value"
                className="img-fluid"
              />
              <h4 className="colorRed fw-800">Engaging Communication</h4>
              <p className="colorBlack fw-400">
                Let’s own the conversations in your space with communication
                that’s bound to make an impact.
              </p>
            </div>
          </div>
          <div className="imageScrollBar wow animate__animated animate__slideInUp">
            <img
              src="/images/about/group.png"
              alt="Our Team"
              className="img-fluid"
              style={{ height: "523px", objectFit: "cover" }}
            />
            <img
              src="/images/about/office.jpg"
              alt="Our Team"
              className="img-fluid"
            />
            <img
              src="/images/about/tushar-sunidhi.jpg"
              alt="Our Team"
              className="img-fluid"
            />
            <img
              src="/images/about/group.png"
              alt="Our Team"
              className="img-fluid"
              style={{ height: "523px", objectFit: "cover" }}
            />
            <img
              src="/images/about/office.jpg"
              alt="Our Team"
              className="img-fluid"
            />
            <img
              src="/images/about/tushar-sunidhi.jpg"
              alt="Our Team"
              className="img-fluid"
            />
          </div>

          <div className="joinOurTribe wow animate__animated animate__slideInUp">
            <h2 className="sectionHead colorBlack fw-800">
              <img src="/images/icons/line.jpg" alt="line" />
              Join our tribe
            </h2>
            <p className="projectDesc colorBlack fw-800">
              To celebrate <span className="colorRed">design!</span>
            </p>
            <span className="colorBlack fw-400">
              We’re always on the lookout for talent. <br /> Come say hello and
              we’ll figure out if <br /> you’re a good fit!
            </span>
          </div>
        </div>
      </section>

      <section className="weareintheNews weareintheNews2">
        <div className="content_container">
          <News />
        </div>
      </section>
    </>
  );
};

export default AboutUs;
